import { useState, useEffect, useRef } from "react";
import { api } from "@/App";

// Rileva un "#token" finale (0+ caratteri): i suggerimenti appaiono appena scrivi "#"
export const getActiveTagToken = (text) => {
  const m = /(^|\s)#(\w{0,30})$/.exec(text || "");
  return m ? m[2] : null;
};

// Sostituisce il #token finale con il tag scelto
export const applyTag = (text, tag) => text.replace(/(^|\s)#(\w{0,30})$/, `$1#${tag} `);

// Chips orizzontali con gli AdE Tag più usati che iniziano col prefisso digitato
export function TagSuggestions({ text, onPick, className = "" }) {
  const [results, setResults] = useState([]);
  const token = getActiveTagToken(text);
  const timer = useRef(null);

  useEffect(() => {
    if (token === null) { setResults([]); return; }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        if (token.length === 0) {
          const r = await api.get("/explore/trending");
          const rows = (r.data.trending?.length ? r.data.trending : r.data.popular) || [];
          setResults(rows.slice(0, 10));
        } else {
          const r = await api.get(`/explore/search?q=${encodeURIComponent(token)}`);
          setResults((r.data.results || []).slice(0, 10));
        }
      } catch {
        setResults([]);
      }
    }, 220);
    return () => clearTimeout(timer.current);
  }, [token]);

  if (token === null || results.length === 0) return null;

  return (
    <div className={`absolute left-0 right-0 z-50 ${className}`} data-testid="tag-suggestions">
      <div className="flex gap-1.5 overflow-x-auto py-1.5 px-0.5" style={{ scrollbarWidth: "none" }}>
        {results.map((t) => (
          <button
            key={t.tag}
            onMouseDown={(e) => { e.preventDefault(); onPick(t.tag); }}
            className="flex-shrink-0 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-bold active:scale-95 transition-transform"
            data-testid={`tag-option-${t.tag}`}
          >
            #{t.tag}
            <span className="ml-1 text-amber-400 font-semibold">{t.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
